import React from "react";
import LiveSoloStreamers, { LiveSoloStreamersProps } from "./LiveSoloStreamers";
import { useLiveStreamers } from "../../hooks/useLiveStreamers";
import { View, Text, ActivityIndicator, StyleSheet } from "react-native";

interface LiveSoloStreamersContainerProps {
  onStreamPress?: LiveSoloStreamersProps["onStreamPress"];
  onUserPress?: LiveSoloStreamersProps["onUserPress"];
}

/**
 * Container component that connects LiveSoloStreamers to the API
 * Fetches live and past streams, handles real-time updates via socket
 */
const LiveSoloStreamersContainer = ({
  onStreamPress,
  onUserPress,
}: LiveSoloStreamersContainerProps) => {
  const { liveStreams, pastStreams, loading, error, refresh } =
    useLiveStreamers();

  if (loading && liveStreams.length === 0 && pastStreams.length === 0) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#655AFF" />
        <Text style={styles.loadingText}>Loading streamers...</Text>
      </View>
    );
  }

  if (error && liveStreams.length === 0 && pastStreams.length === 0) {
    return (
      <View style={styles.errorContainer}>
        <Text style={styles.errorText}>Failed to load streamers</Text>
        <Text style={styles.errorSubtext}>{error}</Text>
      </View>
    );
  }

  return (
    <LiveSoloStreamers
      liveStreams={liveStreams}
      pastStreams={pastStreams}
      onStreamPress={onStreamPress}
      onUserPress={onUserPress}
    />
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    padding: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  loadingText: {
    color: "#999999",
    fontSize: 14,
    marginTop: 12,
  },
  errorContainer: {
    padding: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  errorText: {
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: "600",
  },
  errorSubtext: {
    color: "#999999",
    fontSize: 14,
    marginTop: 8,
  },
});

export default LiveSoloStreamersContainer;
